import { MaybeCompleteCartTemplateDetailsItem, CompleteCartTemplateDetailsItem } from '..'

export const isCompleteCartTemplateDetailsItem = (
  item: MaybeCompleteCartTemplateDetailsItem
): item is CompleteCartTemplateDetailsItem => {
  return (item as CompleteCartTemplateDetailsItem).product.prices !== undefined
}
